const APP_TYPE_MAP = {
    NN: 'nn',
    MOOMOO: 'moomoo'
};

const OPTION_TYPE_MAP = {
    CALL: 'CALL',
    PUT: 'PUT',
    ALL: 'ALL'
};

const OPTION_MARKET_TYPE_MAP = {
    // 美股 - 股票期权
    US_STOCK: 1,
    // 美股 - 指数期权
    US_INDEX: 2,
    // 美股 - 期货期权
    US_FUTURE: 3,
    // 港股-股票期权
    HK_STOCK: 4
};

const LANG_MODE_MAP = {
    HK: 1,
    CN: 0,
    EN: 2
};

//排序字段
const SORT_FIELD = {
    /** 异动发生的时间 */
    EVENT_SORT_TIME: 1,
    /** 到期日 or 距到期天数（到期日 和 距到期天数 的排序结果一样，共用一个枚举值） */
    EVENT_SORT_EXPIRY_DATE: 4,
    /** 成交价 */
    EVENT_SORT_PRICE: 9,
    /** 成交量 */
    EVENT_SORT_VOLUME: 10,
    /** 成交额 */
    EVENT_SORT_TURNOVER: 12,
    /** 隐含波动率 */
    EVENT_SORT_IV: 16,
    /** 期权的delta值 */
    EVENT_SORT_DELTA: 17
};

//展示字段（与后端字段名对齐）
const SHOW_FIELD = {
    DIRECTION: 'direction', //成交方向
    IMPLICIT_VOLATILITY: 'optionIv', //隐含波动率
    PRICE: 'price', //成交价
    VOLUME: 'volume', //成交量
    AMOUNT: 'value', //成交额
    DELTA: 'delta' //Delta值
};

//最多三个展示字段
const MAX_FIELD_LEN = 3;

// 默认请求展示的异动数量
const DEFAULT_REQUEST_UNUSUAL_COUNT = 5;

// 最多请求展示的异动数量
const MAX_REQUEST_UNUSUAL_COUNT = 5;

// 字段格式化默认配置
const DEFAULT_FIELD_CONFIG = {
    txt: '---',
    unitTxt: '',
    cls: '',
    unit: 1,
    hasColor: false,
    hasUnit: false,
    hasRate: false,
    hasNoMinusRate: false
};

//展示字段数据
const SHOW_FIELD_DATA_MAP = {
    //逐笔类型-成交方向
    direction: {
        txt: '---',
        unitTxt: '',
        cls: '',
        hasColor: true,
        hasUnit: false
    },
    /** 隐含波动率, 单位：0.001% */
    optionIv: {
        txt: '---',
        unit: 1000, // 单位：0.001% ，需要除以1000得到实际百分比
        hasColor: false,
        fixedUnit: 2,
        hasUnit: false,
        hasNoMinusRate: true //需要带符号的百分比
    },
    /** 成交价，单位：1/10^9元 */
    price: {
        txt: '---',
        unit: 1e9, // price 数据源单位是 1/10^9 元，需要除以 1e9 得到实际价格
        hasColor: true,
        hasUnit: false,
        fixedUnit: 3,
        hasNoMinusRate: false
    },
    /** 成交额，单位：1/10^9元 */
    value: {
        txt: '---',
        unit: 1e9, // value 数据源单位是 1/10^9 元，需要除以 1e9 得到实际金额
        hasColor: true,
        hasUnit: false,
        fixedUnit: 0,
        hasNoMinusRate: false,
        formatMoney: true
    },
    /** 希腊值 string */
    delta: {
        txt: '---',
        unit: 1e9,
        hasColor: false,
        hasUnit: false,
        hasNoMinusRate: false,
        fixedUnit: 4
    },
    /** 成交量，单位：1张 */
    volume: {
        txt: '---',
        unit: 1,
        hasColor: true,
        hasUnit: false,
        fixedUnit: 0, // 成交量应该是整数，不显示小数位
        hasNoMinusRate: false,
        formatMoney: true
    },
    /** 新ID */
    newId: {
        txt: '---',
        unit: 1,
        hasColor: false,
        hasUnit: false,
        fixedUnit: 0,
        hasNoMinusRate: false,
    },
    default: DEFAULT_FIELD_CONFIG
};

//时间筛选器类型
const TIME_FILTER_TYPE = {
    NONE_TYPE: 0, //不筛选
    USER_TYPE: 1 //用户筛选
};

//异动天数筛选器映射
const MAX_DAY_NUM_MAP = [
    {
        label: '最近1天',
        value: 1
    },
    {
        label: '最近3天',
        value: 3
    },
    {
        label: '最近5天',
        value: 5
    },
    {
        label: '最近10天',
        value: 10
    },
    {
        label: '最近30天',
        value: 30
    }
];

//到期时间筛选器列表
const EXPIRATION_TIME_FILTER_LIST = [
    {
        label: '全部到期时间',
        value: {
            minValue: 0
        }
    },
    {
        label: '0-7天到期(包含0天和7天)',
        value: {
            minValue: 0,
            maxValue: 7
        }
    },
    {
        label: '7-14天到期(包含14天)',
        value: {
            minValue: 7,
            maxValue: 14
        }
    },
    {
        label: '14-30天到期(包含14天和30天)',
        value: {
            minValue: 14,
            maxValue: 30
        }
    },
    {
        label: '30-60天到期(包含30天和60天)',
        value: {
            minValue: 30,
            maxValue: 60
        }
    },
    {
        label: '60天以上到期',
        value: {
            minValue: 60
        }
    }
];

//时间筛选器的个数
const EXPIRATION_TIME_FILTER_LIST_LEN = EXPIRATION_TIME_FILTER_LIST.length;

const REGION_TYPE_MAP = {
    HK: 'HK',
    SG: 'SG',
    US: 'US',
    MY: 'MY',
    JP: 'JP',
    AU: 'AU',
    CA: 'CA'
};

const NUM_MAP = {
    TEN: 10,
    HUNDRED: 100,
    E9: 1e9,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    E3: 1e3,
    ONE_DAY: 24 * 60 * 60
};

const EXPIRATION_TIME_FILTER_TYPE = {
    NONE_TYPE: 0, //不筛选
    DEFAULT_TYPE: 1, //区间筛选
    USER_TYPE: 2 //用户筛选
};

const SORT_TYPE = {
    GREATER_THAN: 0, //大于
    LESS_THAN: 1 //小于
};

// TickerType 枚举值
const TICKER_TYPE = {
    UNKNOWN: 0,
    BUY: 1,
    SELL: 2,
    NEUTRAL: 3
};

// 数值转换常量
const OPTION_IV_UNIT_DIVISOR = 1000; // optionIv 单位转换：0.001% -> %
const PERCENTAGE_MULTIPLIER = 100; // 百分比转换倍数
const DEFAULT_DECIMAL_PLACES = 2; // 默认小数位数

// Mock 数据常量（用于 editor-render.vue）
const MOCK_DATA_CONSTANTS = {
    STRIKE_PRICE_BASE: 210,
    STRIKE_PRICE_INCREMENT: 10,
    VALUE_BASE: 7000,
    VALUE_INCREMENT: 1000,
    IV_BASE: 180.73,
    IV_INCREMENT: 5,
    IV_DECIMAL_PLACES: 2,
    DIRECTION_MODULO: 2,
    PRICE_BASE: 2.5,
    PRICE_INCREMENT: 0.1,
    PRICE_DECIMAL_PLACES: 2,
    VOLUME_BASE: 1000,
    VOLUME_INCREMENT: 100,
    DELTA_BASE: 0.52,
    DELTA_INCREMENT: 0.05,
    DELTA_DECIMAL_PLACES: 2
};

export {
    APP_TYPE_MAP,
    DEFAULT_DECIMAL_PLACES,
    DEFAULT_FIELD_CONFIG,
    DEFAULT_REQUEST_UNUSUAL_COUNT,
    EXPIRATION_TIME_FILTER_LIST,
    EXPIRATION_TIME_FILTER_LIST_LEN,
    EXPIRATION_TIME_FILTER_TYPE,
    LANG_MODE_MAP,
    OPTION_MARKET_TYPE_MAP as MARKET_TYPE_MAP,
    MAX_DAY_NUM_MAP,
    MAX_FIELD_LEN,
    MAX_REQUEST_UNUSUAL_COUNT,
    MOCK_DATA_CONSTANTS,
    NUM_MAP,
    OPTION_IV_UNIT_DIVISOR,
    OPTION_MARKET_TYPE_MAP,
    OPTION_TYPE_MAP,
    PERCENTAGE_MULTIPLIER,
    REGION_TYPE_MAP,
    SHOW_FIELD,
    SHOW_FIELD_DATA_MAP,
    SORT_FIELD,
    SORT_TYPE,
    TICKER_TYPE,
    TIME_FILTER_TYPE
};
